<template>
  <div id="mains">
    <div class="mains-box">
      <div class="mains-container">
        <div class="mains-logo">
          <img src="../../assets/Keeta/1.1.png" alt="" />
        </div>
        <div class="mains-content">
          <ul class="nav-list" @mouseleave="hoverIndex = null">
            <li
              v-for="(item, index) in navItems"
              :key="index"
              :class="[
                'nav-item',
                {
                  active:
                    (hoverIndex === null ? activeIndex : hoverIndex) === index,
                },
              ]"
              @click="scrollToSection(index)"
              @mouseenter="hoverIndex = index"
            >
              <a href="#">{{ item.text }}</a>
            </li>
          </ul>
        </div>
        <div :class="isUK ? '' : 'mains-language'">
          <template v-if="!isUK">
            <img
              src="../../assets/Keeta2/地球icon@2x.png"
              alt=""
              class="language-icon"
            />
            <div class="custom-select" @click="toggleDropdown">
              <div class="selected-option">
                {{ selectedLabel }}
                <span class="arrow">
                  <img
                    :src="
                      dropdownVisible
                        ? require('../../assets/Keeta2/100231@2x.png')
                        : require('../../assets/Keeta/1.3.png')
                    "
                    alt=""
                  />
                </span>
              </div>
              <ul v-if="dropdownVisible" class="options">
                <li
                  v-for="(item, index) in localeList"
                  :key="index"
                  @click.stop="selectOption(item)"
                  :class="{ active: item.value === localeText }"
                >
                  {{ item.label }}
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "MainsView",
  data() {
    return {
      dropdownVisible: false,
      localeText: this.$i18n.locale,
      activeIndex: 0,
      hoverIndex: null,
      localeList: [],
      isUK: false,
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.localeList.find(
        (item) => item.value === this.localeText
      );
      return selected ? selected.label : "";
    },
    navItems() {
      return [
        { text: this.$t("home_mains_about_us"), section: "aboutus" },
        { text: this.$t("home_mains_join_us"), section: "partner" },
        { text: this.$t("home_mains_download"), section: "freedom" },
      ];
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    const country = getCountryByDomain(window.location.hostname);
    if (country === "uk") {
      this.isUK = true;
      this.localeList = [{ value: "en", label: "English" }];
      this.localeText = "en";
      this.$i18n.locale = "en";
    } else if (country === "hongkong") {
      this.localeList = [
        { value: "zh_HK", label: "繁體中文" },
        { value: "zh_CN", label: "简体中文" },
        { value: "en", label: "English" },
      ];
      if (!["zh_HK", "zh_CN", "en"].includes(this.localeText)) {
        this.localeText = "zh_HK";
        this.$i18n.locale = "zh_HK";
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let found = false;
      for (let i = 0; i < this.navItems.length; i++) {
        const sectionId = this.navItems[i].section;
        const section = document.getElementById(sectionId);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 80 && rect.bottom > 80) {
            this.activeIndex = i;
            found = true;
            break;
          }
        }
      }
      if (!found) this.activeIndex = 0;
    },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },
    selectOption(item) {
      this.localeText = item.value;
      this.$i18n.locale = item.value;
      this.dropdownVisible = false;
    },
    setActive(index) {
      this.activeIndex = index;
    },
    scrollToSection(index) {
      this.setActive(index);
      const sectionId = this.navItems[index].section;
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/_variables.scss";
#mains {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1000;
  min-width: $min-width;
  background-color: #f7f8f9;
  // height: 62px;
  display: flex;
  justify-content: center;
  align-items: center;

  .mains-box {
    width: 1200px;
    padding-top: 14.02px;
    box-sizing: border-box;
  }

  .mains-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;

    .mains-logo {
      text-align: center;

      img {
        width: 121px;
        height: auto;
        // margin-top: 3%;
      }
    }

    .mains-content {
      align-items: center;
      margin-bottom: 8px;

      .nav-list {
        display: flex;
        list-style: none;
        font-size: 0.4rem;
        padding: 0;
        margin: 0;

        .nav-item {
          margin-right: 20px;

          a {
            position: relative;
            text-decoration: none;
            color: black;
            padding: 5px 20px;

            &::after {
              content: "";
              position: absolute;
              left: 50%;
              bottom: 0px;
              width: 24px;
              height: 2.5px;
              border-radius: 1.5px;
              background-color: #fcea61;
              transform: translateX(-50%) scaleX(0);
              transition: transform 0.3s ease;
              transform-origin: bottom center;
            }
          }

          &.active a::after {
            transform: translateX(-50%) scaleX(1);
          }
        }
      }
    }
  }

  .mains-language {
    display: flex;
    width: 118px;
    height: 36px;
    margin-bottom: 8px;
    align-items: center;
    background-color: #fff;
    border-radius: 50px;
    padding: 5px 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

    .language-icon {
      width: 18px;
      height: 18px;
      margin-right: 2px;
    }
    .custom-select {
      position: relative;
      width: 100%;
      cursor: pointer;
      .selected-option {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.35rem;
        color: #000;
      }
      .arrow {
        font-size: 0.3rem;
        margin-top: 5px;
        margin-right: 3px;
        img {
          width: 14px;
          height: 14px;
        }
      }
      .options {
        position: absolute;
        top: 150%;
        right: 5px;
        width: 100%;
        background-color: #fff;
        border-radius: 8px;
        list-style: none;
        padding: 0;
        margin: 0;
        z-index: 10;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

        li {
          padding: 10px;
          border-radius: 8px;
          font-size: 0.3rem;
          cursor: pointer;

          &:hover {
            background-color: #f0f0f0;
          }

          &.active {
            background-color: rgba(245, 247, 250);
          }
        }
      }
    }
  }
}
</style>
